import { IColumnDefinition } from "../../../../../bidding/common/table/types/ColumnDefinition";
import { ColumnBuilder } from "../../../../../bidding/common/table/columns/column-builder/ColumnBuilder";
import { SORTING_TYPE } from "../../../../../../constants";
import { formatUtils, moneyUtils } from "../../../../../../utils";
import { OnHoverTooltip } from "../../../../../common";

export interface PortfolioConcentration {
    name: string;
    volume: number;
    percentOfTotal: number;
}

export const concentrationPortfolioColumns = (nameHeader: string) => {
    const portfolioConcentrationColumnDefinitions: IColumnDefinition<PortfolioConcentration>[] =
        [
            {
                columnKey: "name",
                renderColumnHeaderContent: () => nameHeader,
                renderColumnContent: (portfolio) => (
                    <>
                        <OnHoverTooltip overlay={portfolio.name}>
                            {portfolio.name}
                        </OnHoverTooltip>
                    </>
                ),
                sortingField: "name",
                className: "data-list-cell-md-flexible",
                sortingType: SORTING_TYPE.string,
            },
            {
                columnKey: "volume",
                renderColumnHeaderContent: () => "Volume",
                renderColumnContent: (portfolio) =>
                    moneyUtils.money(portfolio.volume, true),
                sortingField: "volume",
                className: "data-list-cell-sm-02 text-right",
                sortingType: SORTING_TYPE.number,
            },
            {
                columnKey: "percentOfTotal",
                renderColumnHeaderContent: () => "% of Total",
                renderColumnContent: (portfolio) =>
                    formatUtils.formatDecimal(portfolio.percentOfTotal),
                sortingField: "percentOfTotal",
                className: "data-list-cell-sm-02 text-right",
                sortingType: SORTING_TYPE.number,
            },
        ];

    return portfolioConcentrationColumnDefinitions.map(
        (c) => new ColumnBuilder(c)
    );
};
